import { Link } from 'react-router-dom';

const footerLinks = {
  guides: [
    { label: 'What Is Litbuy Spreadsheet', to: '/what-is-litbuy-spreadsheet' },
    { label: 'How It Works', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Beginner Guide', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Tips & Tricks', to: '/what-is-litbuy-spreadsheet' },
  ],
  templates: [
    { label: 'Best Templates', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Workflow Templates', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Budget Templates', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Project Templates', to: '/what-is-litbuy-spreadsheet' },
  ],
  safety: [
    { label: 'Safety Guide', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Security Tips', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Privacy Information', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Disclaimer', to: '/what-is-litbuy-spreadsheet' },
  ],
  comparisons: [
    { label: 'vs Traditional', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Feature Comparison', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Productivity Analysis', to: '/what-is-litbuy-spreadsheet' },
    { label: 'Resource Guide', to: '/what-is-litbuy-spreadsheet' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-100">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 py-14 md:py-16">
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Guides</h4>
            <div className="w-8 h-px bg-accent-400 mb-4"></div>
            <ul className="space-y-2.5">
              {footerLinks.guides.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 transition-colors duration-150 cursor-pointer hover:text-primary-600">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Templates</h4>
            <div className="w-8 h-px bg-accent-400 mb-4"></div>
            <ul className="space-y-2.5">
              {footerLinks.templates.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 transition-colors duration-150 cursor-pointer hover:text-primary-600">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Safety</h4>
            <div className="w-8 h-px bg-accent-400 mb-4"></div>
            <ul className="space-y-2.5">
              {footerLinks.safety.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 transition-colors duration-150 cursor-pointer hover:text-primary-600">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">Comparisons</h4>
            <div className="w-8 h-px bg-accent-400 mb-4"></div>
            <ul className="space-y-2.5">
              {footerLinks.comparisons.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-foreground-600 transition-colors duration-150 cursor-pointer hover:text-primary-600">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-background-300/60 py-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
            <div>
              <p className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
                litbuy
                <span className="text-foreground-600 font-normal ml-2">spreadsheets</span>
              </p>
              <div className="w-12 h-px bg-accent-400 mt-2 mb-3"></div>
              <p className="text-xs text-foreground-500 max-w-sm leading-relaxed">
                Your trusted resource for Litbuy Spreadsheet guides, templates, safety information, and comprehensive comparisons. Helping users make informed decisions.
              </p>
            </div>

            <div className="flex flex-col sm:items-end gap-3">
              <div className="flex items-center gap-4">
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 transition-colors duration-150 cursor-pointer hover:bg-primary-500 hover:text-background-50">
                  <i className="ri-shopping-bag-line text-sm"></i>
                </a>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 transition-colors duration-150 cursor-pointer hover:bg-primary-500 hover:text-background-50">
                  <i className="ri-global-line text-sm"></i>
                </a>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 transition-colors duration-150 cursor-pointer hover:bg-primary-500 hover:text-background-50">
                  <i className="ri-star-line text-sm"></i>
                </a>
              </div>
              <p className="text-xs text-foreground-400">
                &copy; 2026 litbuy spreadsheets. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}